import Vue from 'vue';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';

if (process.env.BUGSNAG_API_KEY) {
  Bugsnag.start({
    apiKey: process.env.BUGSNAG_API_KEY,
    plugins: [new BugsnagPluginVue()],
    appVersion: process.env.VERSION,
    releaseStage: process.env.RELEASE,
    // notifyReleaseStages: ['production'],
  });

  Bugsnag.getPlugin('vue')
    .installVueErrorHandler(Vue);

  // Bugsnag.notify(new Error('Test error'));
}

export default Bugsnag;
